<template>
	<div
		hide-footer
		ref="modal-view-promotion"
		size="lg"
		:title="'Promociones'"
	>
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-form>
			<b-form-row>
				<b-form-group label="Nombre" class="col-lg-3 col-6">
					<b-form-input :disabled="!hasPermissionUpdate" v-model="formModel.name" type="text"/>
				</b-form-group>

				<b-form-group label="Codigo" class="col-lg-3 col-6">
					<b-form-input :disabled="!hasPermissionUpdate" v-model="formModel.code " type="text"/>
				</b-form-group>
				<b-form-group label="Dias" class="col-lg-6 col-12 text-center">
					<b-form-checkbox-group  :options="optsDays" v-model="formModel.days"></b-form-checkbox-group>
				</b-form-group>

			</b-form-row>
			<b-form-row>
				<b-form-group label="Hrs previas Min." class="col-lg-2 col-6">
					<b-form-input :disabled="!hasPermissionUpdate" v-model="formModel.hoursInAdvanceMin" type="number"/>
				</b-form-group>
				<b-form-group label="Hrs previas Max" class="col-lg-2 col-6">
					<b-form-input :disabled="!hasPermissionUpdate" v-model="formModel.hoursInAdvanceMax" type="number"/>
				</b-form-group>
				<b-form-group class="col-lg-2 col-3 w-100" label="Hora Inicio">
					<vue-timepicker
						v-model="formModel.scheduleStart"
						manual-input
						class="mb-1"
						ref="vuetimepicker"
						format="HH:mm"
					></vue-timepicker>
				</b-form-group>
				<b-form-group class="col-lg-2 col-3" label="Hora Fin">
					<vue-timepicker
						v-model="formModel.scheduleEnd"
						manual-input
						class="mb-1"
						ref="vuetimepicker"
					></vue-timepicker>
				</b-form-group>
				<b-form-group label="Token" class="col-lg-2 col-6">
					<b-form-input :disabled="!hasPermissionUpdate" v-model="formModel.token" type="text"/>
				</b-form-group>
			</b-form-row>

			<!-- Window quote schedule start -->
			<b-form-row v-if="embbebedOn != 'supplier'">
				<b-form-group class="col-lg-2" label="Hora inicio de cotización">
					<vue-timepicker
						v-model="formModel.windowQuoteScheduleStart"
						manual-input
						class="mb-1"
						ref="vuetimepicker"
						format="HH:mm"
					></vue-timepicker>
				</b-form-group>
				<b-form-group class="col-lg-2" label="Hora fin de cotización">
					<vue-timepicker
						v-model="formModel.windowQuoteScheduleEnd"
						manual-input
						class="mb-1"
						ref="vuetimepicker"
					></vue-timepicker>
				</b-form-group>
			</b-form-row>
			<b-form-row v-if="embbebedOn != 'supplier'">
				<small class="text-danger font-weight-bold ml-1">
					** Si se configura horario de cotización se aplicará aun si la agencia es offline
				</small>
			</b-form-row>
			<!-- Window quote schedule end -->

			<b-form-row>
				<b-form-group label="Modificador precio" class="col-lg-4 col-6">
					<b-form-select v-model="formModel.rateModifierType">
						<b-select-option value="percent">Porcentaje</b-select-option>
						<b-select-option value="amount">Monto</b-select-option>
						<b-select-option value="fixed_rate">Tarifa fija</b-select-option>
					</b-form-select>
				</b-form-group>
				<b-form-group label="Prioridad" class="col-lg-2 col-6">
					<b-form-input :disabled="!hasPermissionUpdate" v-model="formModel.priority" type="number"/>
				</b-form-group>

				<b-form-group label="Limite de usos (Rides)" class="col-lg-4 col-6">
					<b-form-input :disabled="!hasPermissionUpdate" v-model="formModel.tokenLimit" type="number"/>
					<small class="text-danger font-weight-bold">
						** Límite de uso solo aplica para códigos de promoción
					</small>
				</b-form-group>
			</b-form-row>

			<b-form-row>
				<b-form-group class="col-lg-12 col-12" label="description">
					<b-form-textarea :disabled="!hasPermissionUpdate" v-model="formModel.description" placeholder="Escriba aqui..." rows="1" />
				</b-form-group>
			</b-form-row>
		</b-form>
		<hr>

		<section>
			<h4>Configuración de fechas</h4>
			<b-form-row>
				<b-col class="col-lg-6 col-12 p-4">
					<h5 class="text-center">Booking window</h5>
					<DateComponent ref="bookingWindowModule"></DateComponent>
				</b-col>
				<b-col class="col-lg-6 col-12 p-4">
					<h5 class="text-center">Booking window blackout</h5>
					<DateComponent ref="bookingWindowBlockoutModule" ></DateComponent>
				</b-col>
			</b-form-row>

			<b-form-row>
				<b-col class="col-lg-6 col-12 p-4">
					<h5 class="text-center">Travel window</h5>
					<DateComponent ref="travelWindowModule"></DateComponent>
				</b-col>
				<b-col class="col-lg-6 col-12 p-4">
					<h5 class="text-center">Travel window blackout</h5>
					<DateComponent ref="travelWindowBlockoutModule"></DateComponent>
				</b-col>
			</b-form-row>

			<b-form-row v-if="embbebedOn=='supplier'">
				<b-col class="col-lg-6 col-12 p-4">
					<h5 class="text-center">Assigned window</h5>
					<DateComponent ref="assignedWindowModule"></DateComponent>
				</b-col>
				<b-col class="col-lg-6 col-12 p-4">
					<h5 class="text-center">Assigned window blackout</h5>
					<DateComponent ref="assignedWindowBlockoutModule"></DateComponent>
				</b-col>
			</b-form-row>
		</section>
		<hr>
		<h4>Configuración promoción</h4>
		<b-form-row>
			<b-col class="col-lg-12 col-12 p-4">
				<SettingsPromotions ref="promotionSettingsModule" :embbebedOn="embbebedOn" :embbebedOnId="embbebedOnId" :formModelPromo="formModel"></SettingsPromotions>
			</b-col>
		</b-form-row>

		<b-form-row>
			<b-form-group label="Canales de venta" class="col-lg-12">
				<multiselect
					:disabled="!hasPermissionUpdate"
					v-model="formModel.salesChannels"
					tag-placeholder="Add this as new tag"
					placeholder="Search or add a tag"
					label="name"
					track-by="id"
					:custom-label="($row)=>{return `[${$row.id}]  ${$row.name}`}"
					:options="optionSalesChannels"
					:multiple="true"
					:taggable="true"/>
			</b-form-group>
		</b-form-row>
		<b-row>
			<b-col class="text-right mr-4 mt-5">
				<b-button @click="save()" size="lg" variant="primary">
					Guardar
				</b-button>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import DateComponent from "./DatesComponent"
import SettingsPromotions from "./SettingsComponent"
import VueTimepicker from "vue2-timepicker";
import Multiselect from 'vue-multiselect';
export default {
	props: {
		embbebedOn:{
			type: [String],
			required: true,
		},
		embbebedOnId:{
			type: [String, Number],
			required: true,
		},
		promotionEdit: {
			type: [Object],
			default: null
		}
	},
	components: {DateComponent,SettingsPromotions,VueTimepicker,Multiselect},
	data() {
		let defaultModelInfo = {
			name:"",
			code:"",
			description:"",
			hoursInAdvanceMin:0,
			hoursInAdvanceMax:0,
			days:[0,1,2,3,4,5,6],
			token:"",
			tokenLimit:0,
			scheduleStart:'',
			scheduleEnd:'',
			windowQuoteScheduleStart: '',
			windowQuoteScheduleEnd: '',
			ratePlanId:null,
			rateModifierType:"percent",
			dates:{}
		};
		return {
			loading:false,
			formModel:{...defaultModelInfo},
			optsDays:[
				{ text: "Do", value: "0" },
				{ text: "Lu", value: "1" },
				{ text: "Ma", value: "2" },
				{ text: "Mi", value: "3" },
				{ text: "Ju", value: "4" },
				{ text: "Vi", value: "5" },
				{ text: "Sa", value: "6" },
			]
		};
	},
	computed: {
		hasPermissionUpdate(){
			let permissionAdd = this.$hasPermission('promotion.supplier.add');
			let permissionUpdate = this.$hasPermission('promotion.supplier.update');
			//se esta editando?
			if(this.modelPromotion != null){
				if(permissionUpdate) {
					return true;
				}
			}else{//es nuevo?
				if(permissionAdd) {
					return true;
				}
			}
			return false;
		},
		formModelCleaned(){
			let model = {...this.formModel};
			if(!this.$root.isEmpty(model.salesChannels)){
				model.salesChannels = this.formModel.salesChannels.map((_item)=>{
					return _item.id
				})
			}

			model.dates = {
				bookingWindow: this.$refs["bookingWindowModule"].getData(),
				bookingWindowBlockout : this.$refs["bookingWindowBlockoutModule"].getData(),
				travelWindow: this.$refs["travelWindowModule"].getData(),
				travelWindowBlockout : this.$refs["travelWindowBlockoutModule"].getData()
			}
			if(!this.$root.isEmpty(this.$refs["assignedWindowModule"])){//si aplica
				model.dates.assignedWindow         = this.$refs["assignedWindowModule"].getData();
				model.dates.assignedWindowBlockout = this.$refs["assignedWindowBlockoutModule"].getData();
			}
			model   = {...model,...this.$refs["promotionSettingsModule"].getData()}
			return model;
		},
		optionSalesChannels(){
			return [...this.$root.auxVars.salesChannelsOpts.map(item=>{return {id:item.value, name:item.text}})];
		},
	},
	methods: {
		save(){
			if(!this.$root.isEmpty(this.promotionEdit) && this.promotionEdit.id>0){
				this.update();
			}else{
				this.store();
			}
		},
		store(){
			this.loading= true;
			this.$root.api.post(`/promotions/${this.embbebedOn}/${this.embbebedOnId}`, this.formModelCleaned)
				.then(() => {
					this.loading =false;
					this.$emit('refreshTable');
					this.$root.showAlert(`Se registro correctamente`);
				}).catch((error)=>{
					this.loading =false;
					this.$root.handleRequestError(error);
				});
		},
		update(){
			this.loading = true;
			this.$root.api.put(`/promotions/${this.embbebedOn}/${this.embbebedOnId}/${this.promotionEdit.id}`, this.formModelCleaned)
			.then(() => {
				this.loading =false;
				this.$emit('refreshTable')
				this.$root.showAlert(`Se actualizó correctamente`);
			}).catch((error)=>{
				this.loading =false;
				this.$root.handleRequestError(error);
			});
		},
		loadPromoEdit(){
			this.formModel = {...this.promotionEdit};
			this.$refs["promotionSettingsModule"].setData(this.formModel)
			//------Fechas--------//
			this.$refs["bookingWindowModule"].setData(this.formModel.dates.bookingWindow);
			this.$refs["bookingWindowBlockoutModule"].setData(this.formModel.dates.bookingWindowBlockout);
			this.$refs["travelWindowModule"].setData(this.formModel.dates.travelWindow);
			this.$refs["travelWindowBlockoutModule"].setData(this.formModel.dates.travelWindowBlockout);
			if(!this.$root.isEmpty(this.$refs["assignedWindowModule"])){
				this.$refs["assignedWindowModule"].setData(this.formModel.dates.assignedWindow);
				this.$refs["assignedWindowBlockoutModule"].setData(this.formModel.dates.assignedWindowBlockout);
			}
			//-------------------//
		},
		getCleanedData(){

		}
	},
	mounted() {
		if(!this.$root.isEmpty(this.promotionEdit)){
			this.loadPromoEdit();
		}
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: [
				"salesChannelsOpts"
			]
		});

		console.log(this.embbebedOn, this.embbebedOnId)
	},
	watch: {

	}
};
</script>

<style>
.stacked-options .multiselect__tag {
	float: left;
}
</style>
